import React, { useState, useEffect } from 'react';
import './EditBuildingModal.css';

const EditBuildingModal = ({ isOpen, onClose, building, onSave }) => {
  const [buildingName, setBuildingName] = useState(building?.buildingName || '');
  const [buildingTotalArea, setBuildingTotalArea] = useState(building?.buildingTotalArea || '');
  const [buildingGroundFloor, setBuildingGroundFloor] = useState(building?.buildingGroundFloor || '');
  const [buildingBasementFloor, setBuildingBasementFloor] = useState(building?.buildingBasementFloor || '');
  const [buildingWaterMeter, setBuildingWaterMeter] = useState(building?.buildingWaterMeter || '');

  useEffect(() => {
    setBuildingName(building?.buildingName || '');
    setBuildingTotalArea(building?.buildingTotalArea || '');
    setBuildingGroundFloor(building?.buildingGroundFloor || '');
    setBuildingBasementFloor(building?.buildingBasementFloor || '');
    setBuildingWaterMeter(building?.buildingWaterMeter || '');
  }, [building]);

  useEffect(() => {
    const detailInfoRow = document.querySelector('.detail-specific-info-row');

    if (isOpen && detailInfoRow) {
      detailInfoRow.classList.add('detail-specific-info-row-darkened');
    } else if (detailInfoRow) {
      detailInfoRow.classList.remove('detail-specific-info-row-darkened');
    }

    return () => {
      if (detailInfoRow) {
        detailInfoRow.classList.remove('detail-specific-info-row-darkened');
      }
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSave = () => {
    onSave({
      ...building,
      buildingName,
      buildingTotalArea,
      buildingGroundFloor,
      buildingBasementFloor,
      buildingWaterMeter,
    });

    // console.log("지상:", buildingGroundFloor)
    // console.log("지하:", buildingBasementFloor)

    onClose();
    // window.location.reload();
  };

  return (
    <div className="edit-building-modal">
      <div className="edit-building-modal-content">
        <h2>건물 정보 수정</h2>
        <div className='edit-building-modal-input-field'>
            <label>
            건물명
            <input
                type="text"
                value={buildingName}
                onChange={(e) => setBuildingName(e.target.value)}
            />
            </label>
            <label>
            연면적(m²)
            <input
                type="number"
                value={buildingTotalArea}
                onChange={(e) => setBuildingTotalArea(e.target.value)}
            />
            </label>
            <label>
            지상 층 수
            <input
                type="number"
                value={buildingGroundFloor}
                onChange={(e) => setBuildingGroundFloor(e.target.value)}
            />
            </label>
            <label>
            지하 층 수
            <input
                type="number"
                value={buildingBasementFloor}
                onChange={(e) => setBuildingBasementFloor(e.target.value)}
            />
            </label>
            <label>
            건물 수도 계량기 번호
            <input
                type="text"
                value={buildingWaterMeter}
                onChange={(e) => setBuildingWaterMeter(e.target.value)}
            />
            </label>
        </div>
        <div className="edit-building-modal-buttons">
            <button onClick={onClose}>취소</button>
            <button onClick={handleSave}>수정 완료</button>
        </div>
      </div>
    </div>
  );
};

export default EditBuildingModal;
